module.exports = __webpack_public_path__ + "static/a-xx-228-art-db257791ff22a7b6bcb0c8263ad1f616.jpg";